export const Logo = ({ testId = "logo" }) => (
  <span className="flex items-center gap-2.5" data-testid={testId}>
    <img
      src="/media/mac-logo-square.png"
      alt="MAC AI logo"
      className="h-9 w-9 rounded-full border border-mac-accent/50 object-cover shadow-[0_0_18px_rgb(var(--mac-accent-rgb)/0.3)]"
    />
    <span className="font-display text-2xl font-bold leading-none tracking-widest">
      <span className="bg-gradient-to-r from-white to-[#8db8ff] bg-clip-text text-transparent">MAC</span>
      <span className="text-mac-accent"> AI</span>
    </span>
  </span>
);
